/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Shadow_Size_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Shadow Size" |
*
* @param {Styles_Shadow_Size_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_shadow_size_aria_label = /** @type {((inputs?: Styles_Shadow_Size_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Shadow_Size_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Taille d'ombre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schattengröße")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dimensione dell'ombra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Размер тени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tamaño de la sombra")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("阴影大小")
	if (locale === "ja") return /** @type {LocalizedString} */ ("影のサイズ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("छाया का आकार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tamanho da sombra")
	return /** @type {LocalizedString} */ ("Shadow Size")
});